import React from 'react';
import wrapStore from '@src/utils/wrap-store';
import kvPageStore from './store';
import cx from 'classnames';
import toWebpImage from '@src/utils/to-webp-image';
import Link from '@src/components/link';
import { $$tracker } from '@src/tracker';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
const lang = getLanguageByPath();

const styles = require('./index.less');

const kvPage = ({ store }) => {
  store.use();

  // slogan 目前没有设计 先搞个dom承接后续在写样式 其余的都接入数据了
  // 活动入口
  const RenderActivityEntry = () => {
    return (
      <div className={cx(styles.activityEntry)} data-name="活动入口">
        {/* {store.sellStatus} */}
        {/* <Link
          className={cx(styles.activityBtn1)}
          onClick={() => {
            store.clickGiftPack();
            $$tracker.clickHomeSidebar('特装机典藏版');
          }}
          data-name="典藏礼盒"
        >
          <div className={styles.dclb} />
        </Link> */}
        {/* 建站通用配置活动-Twitch Drops等..... */}
        {store?.activityList.map(
          (item, index) =>
            item.activity_state === '1' && (
              <Link
                href={item.is_only_pc === '0' ? item?.activity_url : undefined}
                target={'_blank'}
                key={index}
                className={styles.activityBtn1}
                data-name={item.title}
                onClick={() => {
                  store.activityClick(item.is_only_pc, item.activity_url);
                  $$tracker.clickHomeSidebar(item.title);
                }}
              >
                <div className={styles.dclb} style={{ backgroundImage: `url(${item.cover_mo})` }} />
              </Link>
            )
        )}
      </div>
    );
  };
  return (
    <div className={cx(styles.root, store.isActive && styles.rootAvtive)}>
      <div
        className={styles.kv}
        style={{
          backgroundImage: `url(${toWebpImage(require('./images/' + store.mainStore.Lang() + '/kv.jpg'))})`
        }}
      >
        {/* <div className={styles.slogan} style={{ backgroundImage: `url(${store.page1Data?.slogan})` }} data-name="" /> */}
        {JSON.stringify(store.page1Data?.hongdong1)}
        {RenderActivityEntry()}
        <Link
          className={cx(styles.videoBtn)}
          onClick={() => {
            store.openVideo();
          }}
        />

        <Link
          className={cx(styles.downLoadBtn)}
          style={{
            backgroundImage: `url(${toWebpImage(require('./images/' + store.mainStore.Lang() + '/download-btn.png'))})`
          }}
          onClick={() => {
            store.download();
          }}
        />
        <div className={styles.xboxSteam}>
          <Link
            className={cx(styles.steam)}
            style={{
              backgroundImage: `url(${toWebpImage(require('./images/steam.png'))})`
            }}
            href={store.page1Data?.steam_link}
            target="_blank"
            onClick={() => {
              $$tracker.clickHomeSteam();
            }}
          />
          <Link
            className={cx(styles.xbox)}
            style={{
              backgroundImage: `url(${toWebpImage(require('./images/xbox.png'))})`
            }}
            href={store.page1Data?.xbox_link}
            target="_blank"
            onClick={() => {
              $$tracker.clickHomeXbox();
            }}
          />
          {store.page1Data?.GP_status && (
            <Link
              className={cx(styles.gp)}
              style={{
                backgroundImage: `url(${toWebpImage(require('./images/GP.png'))})`
              }}
              href={store.page1Data?.GP_link}
              target="_blank"
              onClick={() => {
                $$tracker.clickHomeGPG();
              }}
            />
          )}
        </div>

        <div
          className={styles.slogan}
          style={{ backgroundImage: `url(${toWebpImage(require('./images/' + store.mainStore.Lang() + '/slogan.png'))})` }}
          data-name=""
        />
      </div>
    </div>
  );
};

export default wrapStore(kvPage, kvPageStore);
